<script setup lang="ts">
import type { OperationStatus } from "~/core/models/OperationStatus.enum";
import { EMPTY_TOOLTIP } from "~/modules/dtwin/constants";
import { DtwinMetadataStatus } from "~/modules/dtwin/models/DtwinMetadataStatus.enum";
import {
  compute,
  computeOperationStatusesColor,
} from "~/modules/dtwin/utils/dtwinsListMetadataStatus";
import ILxCircleFilled from "~icons/lxc-business/circle-filled";
import ILxMetaStatusError from "~icons/lxc-business/metastatus-error";
import ILxMetaStatusMixed from "~icons/lxc-business/metastatus-mixed";
import ILxMetaStatusSuccess from "~icons/lxc-business/metastatus-success";

const { t } = useI18n();

const props = defineProps<{
  operationStatuses: Record<string, OperationStatus> | undefined;
  showSimplifiedPictogram?: boolean | undefined;
}>();

const metadataStatus: ComputedRef<DtwinMetadataStatus> = computed(() => {
  return compute(props.operationStatuses);
});

const tooltip: ComputedRef<string> = computed(() => {
  switch (metadataStatus.value) {
    case DtwinMetadataStatus.SUCCESS:
      return `${t("dtwins.list.attributes.metastatus.status.success")}`;
    case DtwinMetadataStatus.MIXED:
      return `${t("dtwins.list.attributes.metastatus.status.mixed")}`;
    case DtwinMetadataStatus.ERROR:
      return `${t("dtwins.list.attributes.metastatus.status.error")}`;
    case DtwinMetadataStatus.UNKNOWN:
    default:
      return EMPTY_TOOLTIP;
  }
});
</script>

<template>
  <span v-if="showSimplifiedPictogram" :title="tooltip">
    <i-lx-circle-filled
      :class="`text-${computeOperationStatusesColor(operationStatuses)}`"
      width="1.25em"
      height="1.25em"
    />
  </span>
  <span v-else :title="tooltip" class="block mx-auto w-fit">
    <i-lx-meta-status-error
      v-if="metadataStatus === DtwinMetadataStatus.ERROR"
    />
    <i-lx-meta-status-mixed
      v-if="metadataStatus === DtwinMetadataStatus.MIXED"
    />
    <i-lx-meta-status-success
      v-if="metadataStatus === DtwinMetadataStatus.SUCCESS"
    />
  </span>
</template>
